import React from 'react';
import PillarPageTemplate from '../../components/PillarPageTemplate';
import { l5eRykerData } from '../../data/pillars/l5eRyker';

export default function PillarL5eRyker() {
  return <PillarPageTemplate data={l5eRykerData} />;
}
